import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
  ModalSheetTitle,
} from 'components/ModalSheet'
import { DocumentRequestDialogViewModel } from './DocumentRequestDialogViewModel'
import React from 'react'
import { observer } from 'mobx-react'
import Checkbox from 'components/Checkbox'
import styles from './DocumentRequestDialog.sass'
import Button from 'components/Button'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'

interface DocumentRequestDialogProps {
  vm: DocumentRequestDialogViewModel
}

export default observer(function DocumentRequestDialog({
  vm,
}: DocumentRequestDialogProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>Report open items</ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        {vm.activate.match({
          pending: () => <ContentLoading compact />,
          rejected: (err) => <ContentError error={err} />,
          resolved: () => <DocumentRequestContent vm={vm} />,
        })}
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Close</Button>
          <Button onClick={vm.submit} type="primary">
            Report Open Items
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

const DocumentRequestContent = observer(function DocumentRequestDialog({
  vm,
}: DocumentRequestDialogProps) {
  return (
    <ModalSheetSection spaced>
      <div className={styles.listHeaderTitle}>Select all that apply</div>

      {vm.documentTypes
        .filter((t) => t.uploaderUserType === 'CLIENT')
        .map((t) => (
          <div
            key={t.id}
            className={styles.itemCell}
            onClick={() => vm.toggle(t)}
          >
            <Checkbox checked={vm.selectedDocumentTypes.includes(t)} />
            <div className={styles.itemTitle}>{t.name}</div>
          </div>
        ))}
    </ModalSheetSection>
  )
})
